import { commonAPI, reportAPI } from '@/services-ts/axios'
import type {
  IGetWordGameReport,
  IGetWordSearchGamesForAdmin,
  IWordGamePayload,
} from '@/types/Request'
import type { IWordGameStore } from '@/types/Store/State'
import { Alert, Format } from '@/utils-ts'
import { defineStore } from 'pinia'

export const useWordGameStore = defineStore('wordGame', {
  state: (): IWordGameStore => ({
    wordGameList: {
      data: [],
      total: 0,
    },
    wordGameReport: {
      data: [],
      total: 0,
    },
  }),

  actions: {
    async CreateWordGame(payload: IWordGamePayload) {
      const { status } = await commonAPI.WordGameService.CreateWordGame(payload)
      if (status) {
        void Alert({ message: Format('admin_global_success'), type: 'success' })
      }
      return status
    },

    async UpdateWordGame(payload: IWordGamePayload) {
      const { status } = await commonAPI.WordGameService.UpdateWordGame(payload)
      if (status) {
        void Alert({ message: Format('admin_global_success'), type: 'success' })
      }
      return status
    },

    async DeleteWordGame(Id: string) {
      const { status } = await commonAPI.WordGameService.DeleteWordGame(Id)
      if (status) {
        this.wordGameList.data = this.wordGameList.data.filter(item => item.id !== Id)
        void Alert({ message: Format('admin_global_deleted'), type: 'success' })
      }
      return status
    },

    async GetWordGameById(Id: string) {
      const { status, data } = await commonAPI.WordGameService.GetWordGameById(Id)
      if (status) {
        return data
      }
      return null
    },

    async GetWordGameReport(payload: IGetWordGameReport) {
      const { status, data, total } =
        await reportAPI.WordGameReportServices.GetWordGameReport(payload)
      if (status && data) {
        this.wordGameReport = { data, total: total ?? data.length }
      } else {
        this.wordGameReport = { data: [], total: 0 }
      }
      return this.wordGameReport.data
    },

    async GetWordSearchGamesForAdmin(payload: IGetWordSearchGamesForAdmin) {
      const { status, data, total } =
        await commonAPI.WordGameService.GetWordSearchGamesForAdmin(payload)
      if (status) {
        this.wordGameList.data = data
        this.wordGameList.total = total || 0
      }
      return status
    },

    async DownloadWordGameReport(payload: IGetWordGameReport) {
      await reportAPI.WordGameReportServices.GetWordGameReportExcel(payload)
    },

    $RESET() {
      this.wordGameList = {
        data: [],
        total: 0,
      }
      this.wordGameReport = {
        data: [],
        total: 0,
      }
    },
  },
})
